<div class="dimensions">
    <div class="navBarView d-flex justify-content-around align-items-center">
        <h4>Journal Buddy</h4>
    </div>
    <div class="bodyContent d-flex flex-column justify-content-between">
        <div class="height70">
            <div class="w-100  d-flex justify-content-center py-4">
                <input class="w-75" type="text" placeholder="Search.." [(ngModel)]="search">
                <img src="../../assets/search.png" class="ml-2 searchSizing" alt="searchIcon" (click)="showOctober()">
            </div>
            <div class="d-flex w-100 justify-content-around">
                <div class="d-flex flex-column align-items-center">
                    <a routerLink="/October2020"> <img src="../../assets/folderIcon.png" class="folderSizing" alt="folderIcon"> </a>
                    <div class="textColour">October 2020</div>
                </div>
                <div class="d-flex flex-column align-items-center" *ngIf="isOctober">
                    <img src="../../assets/folderIcon.png" class="folderSizing" alt="folderIcon">
                    <div class="textColour">September 2020</div>
                </div>
            </div>
            <div class="d-flex w-100 justify-content-around " *ngIf="isOctober">
                <div class="d-flex flex-column align-items-center">
                    <img src="../../assets/folderIcon.png" class="folderSizing" alt="folderIcon">
                    <div class="textColour">August 2020</div>
                </div>
                <div class="d-flex flex-column align-items-center" *ngIf="isOctober">
                    <img src="../../assets/folderIcon.png" class="folderSizing" alt="folderIcon">
                    <div class="textColour">July 2020</div>
                </div>
            </div>
        </div>
        <div class="height10 d-flex justify-content-end align-items-center pr-3 pb-3">
            <img src="../../assets/bluemic.png" class="micSizing" alt="folderIcon" (click)="micMechanism()">
        </div>
    </div>
    <div class="bottomNavBar d-flex border-top border-dark justify-content-around align-items-center">
        <div class="d-flex flex-column align-items-center">
            <img src="../../assets/trends.png" class="dashboardSizing" alt="folderIcon">
            <div class="">Dashboard</div>
        </div>
        <div class="d-flex flex-column align-items-center">
            <img src="../../assets/history.png" class="historySizing" alt="folderIcon">
            <div class="">History</div>
        </div>
        <div class="d-flex flex-column align-items-center">
            <img src="../../assets/settings.png" class="settingSizing" alt="folderIcon">
            <div class="">Setting</div>
        </div>
    </div>
</div>